import hello from 'hellojs';
import { default as getIdpConfig } from './getIdpConfig';
import type { OAuthProviderType } from '../contracts/SharedProperties';

export default function initalizeIdp(provider: OAuthProviderType, clientId: string): void {
    var config = getIdpConfig(provider, clientId);
    hello.settings.scope = '';
    hello.init(config);
}
